import { ElementRef } from '@angular/core';
import { BootstrapDialogLink } from './bootstrap-dialog-link';

/**
 * An action that a user can select. An array of actions is passed into <dialog-frame actions='...'> and
 * they are rendered as buttons in the bottom of the panel. If the linkType is set to 'actionClick-event'
 * then the actionClicked event should be used: <dialog-frame (actionClicked)='...'>
 */
export interface BootstrapDialogAction<T = unknown> extends BootstrapDialogLink<T> {

	/** A unique identifier for this action. e.g. 'save' */
	id: string,

	/** If true, the dialog will be closed when the button is clicked, after the action is applied. */
	willCloseDialog: boolean,

	cssClass?: string,
	enabled: boolean,
	visible: boolean,
	recordId?: number,
	data?: T,
	commonForm?: BaseCommonForm,
	result?: BootstrapDialogResult
}

/** Abstract class as an interface?? */
export abstract class BaseCommonForm {
	abstract setSubmitButton(
		button: ElementRef<HTMLButtonElement>,
		onSubmit: () => Promise<void>
	): void;
}

export interface BootstrapDialogResult {
	id: number;
	isSuccess: boolean;
	data?: unknown;
}